export var CategoryInclude = {
    scope: true,
    image: true,
    subcategories: {
        include: {
            activityDataSourceMappings: {
                include: {
                    activityDataSource: {
                        include: {
                            organizations: {
                                select: { id: true },
                            },
                        },
                    },
                    calculationMethod: {
                        include: {
                            type: {
                                select: { key: true, optionalInputs: true },
                            },
                        },
                    },
                },
            },
        },
    },
};
//# sourceMappingURL=Category.js.map